import { isAdmin } from "../../utilities/permissions";

// Admin Tools opens the deck builder on its own page; Audience Insights >
// Activation opens it as a sub-page, so the sub-menu and the selected
// "Audience Insights" header item stay, as for the Bulk Reporting Tool.
export const INSIGHTS_DECK_BUILDER_PATH = "/insights-deck";
export const INSIGHTS_DECK_BUILDER_ID = "activation insights deck builder";
export const INSIGHTS_DECK_BUILDER_ACTIVATION_PATH =
	"/audience-insights/activation-insights-deck-builder";
export const INSIGHTS_DECK_BUILDER_TITLE = "Audience Insights: Insights Deck Builder";
// ASB-4556: the Admin Tools page's band carries the product name alone, no
// subtitle, no breadcrumb (decided 2026-10-19). Title case, as every AMS band.
export const INSIGHTS_DECK_BUILDER_ADMIN_TITLE = "Insights Deck Builder";

// ASB-4257: Audience Insights > Activation lists the Insights Deck Builder only
// for a publisher whose "insightsDeckBuilderEnabled" setting is on, read from
// the tag's publisherSettings as the Bulk Reporting Tool's is; the API
// enforces it too. The contextual AMS flavor gets no Activation tools, so the
// setting alone does not open it to that flavor.
export const insightsDeckBuilderEnabled = (tagData) =>
	!!tagData?.publisherSettings?.insightsDeckBuilderEnabled &&
	tagData?.publisherSettings?.ams_flavor !== "contextual";

// The Admin Tools page opens for an admin whatever the setting; the Activation
// sub-page follows the setting for everyone, admins included (DB-DC).
export const canOpenInsightsDeckBuilder = (roleId, tagData, { inAudienceInsights = false } = {}) =>
	(!inAudienceInsights && isAdmin(roleId)) || insightsDeckBuilderEnabled(tagData);

// Shown when the ArcTag read fails, since the publisher's setting (and so
// access to the page) is then unknown.
export const INSIGHTS_DECK_BUILDER_LOAD_ERROR =
	"This page could not be loaded. Refresh the page to try again. If it continues, contact AMS support.";
